import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheck, FaPhone, FaEnvelope } from 'react-icons/fa';
import { getServiceData } from '../../data/serviceData';
import Footer from '../layout/Footer';
import './services/ServicePage.css';

const ServiceDetailPage = () => {
  const { serviceSlug } = useParams();
  const navigate = useNavigate();
  
  // Convert slug back to service name
  const serviceName = serviceSlug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  
  const serviceData = getServiceData(serviceName);

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="service-detail">
      <div className="container">
        {/* Back Button */}
        <button className="back-button" onClick={() => navigate('/')}>
          <FaArrowLeft />
          Back to Services
        </button>

        {/* Header Section */}
        <div className="service-header">
          <h1 className="service-title">{serviceName}</h1>
          <p className="service-subtitle">{serviceData.description}</p>
        </div>

        {/* Image Section */}
        <div className="image-section">
          <div className="image-container">
            <img
              src={serviceData.imageUrl}
              alt={serviceName}
              className="main-image"
              onError={(e) => {
                e.target.src = '/images/services/roofing/roofing1.webp';
              }}
            />
          </div>
        </div>

        {/* Features Section */}
        <div className="features-section">
          <h2 className="section-title">What We Offer</h2>
          <div className="features-grid">
            {serviceData.features.map((feature, index) => (
              <div key={index} className="feature-item">
                <div className="feature-icon">
                  <FaCheck />
                </div>
                <span className="feature-text">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Process Section */}
        <div className="process-section">
          <h2 className="section-title">Our Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Consultation</h3>
                <p>We start with a detailed consultation to understand your needs and vision.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Planning & Design</h3>
                <p>Our team creates detailed plans and designs tailored to your project.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Execution</h3>
                <p>Professional installation and construction with quality materials.</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Completion</h3>
                <p>Final inspection, cleanup, and walkthrough to ensure your satisfaction.</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <h2 className="cta-title">Ready to Get Started?</h2>
          <p className="cta-subtitle">Contact us today for a free consultation and estimate.</p>
          <div className="cta-buttons">
            <button className="cta-button primary" onClick={handleContactClick}>
              <FaPhone />
              Get Free Estimate
            </button>
            <button className="cta-button secondary" onClick={handleContactClick}>
              <FaEnvelope />
              Ask Questions
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceDetailPage;
